const communityFallbackPaths = ['/campaigns', '/skills'];

function isMenuItemPathPresent(menuList, path) {

  for (let menuItem of menuList) {
    if (menuItem.path === path) {
      return true;
    }
  }

  return false;

}

export function buildMenuList(fullMenuList, hiddenMenuItemNames) {

  const menuList = [];

  for (let menuItem of fullMenuList) {
    if (hiddenMenuItemNames.indexOf(menuItem.name) === -1) {
      menuList.push(menuItem);
    }
  }

  return menuList;

}

export function determineCommunityFallbackPath(menuList) {

  for (let path of communityFallbackPaths) {
    if (isMenuItemPathPresent(menuList, path) === true) {
      return path;
    }
  }

  return menuList[0].path;

}
